import { useState, useCallback } from "react";

const useFieldDropIndex = (initialIndex = 0) => {
  const [index, setIndex] = useState(initialIndex);
  // useCallback to memoize setIndex for Carousel
  const handleSelect = useCallback((selectedIndex) => {
    setIndex(selectedIndex);
  }, []);
  return [index, handleSelect];
};

export default useFieldDropIndex;
